import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { flattenSlotLayout } from '@core-engine/schema/slot-layout/flatten-slot-layout.js'

export function getTabSlotFields(slot: unknown): SchemaField[] {
  return flattenSlotLayout(slot)
}
